import { Component } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { PATIENTS_BY_DOCTOR_CONTANTS } from './patients-by-doctor.constants';
import { PatientsByDoctorService } from './patients-by-doctor.service';

@Component({
  selector: 'ms-patients-by-doctor',
  templateUrl: './patients-by-doctor.template.html',
  styleUrls: ['./patients-by-doctor.styles.scss']
})
export class PatientsByDoctorComponent extends BaseComponent {

  readonly screen = PATIENTS_BY_DOCTOR_CONTANTS;
  protected setScreen = true;
  report: any[] = [];
  reportDate = new Date();

  constructor(
    protected service: PatientsByDoctorService
  ) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.service.getPatientsByDoctor(this.reportDate).subscribe(report => this.report = report)
    );
  }

  onDateChanged = ({ value }: any) => {
    this.reportDate = value;
    this.subscriptions.push(
      this.service.getPatientsByDoctor(this.reportDate).subscribe(report => this.report = report)
    );
  }

}
